/**
 * @generated SignedSource<<9873c99e12ab9bcdd074a01d4c798fd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreAvailability = "NONE" | "PRIVATE" | "PUBLIC";
import { FragmentRefs } from "relay-runtime";
export type StoreLinkedMembershipModal_query$data = {
  readonly membership: {
    readonly __typename: "MembershipPackage";
    readonly assignable: boolean;
    readonly club: {
      readonly timeZone: string;
    };
    readonly storeAvailability: StoreAvailability;
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_package" | "packageIsAvailableForSale_package">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly session: {
    readonly " $fragmentSpreads": FragmentRefs<"StorePackageModal_session">;
  } | null | undefined;
  readonly " $fragmentType": "StoreLinkedMembershipModal_query";
};
export type StoreLinkedMembershipModal_query$key = {
  readonly " $data"?: StoreLinkedMembershipModal_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreLinkedMembershipModal_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "membershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreLinkedMembershipModal_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Session",
      "kind": "LinkedField",
      "name": "session",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StorePackageModal_session"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "membership",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "membershipId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "assignable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "storeAvailability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "timeZone",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "packageIsAvailableForSale_package",
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DisplayInApp",
                      "kind": "LinkedField",
                      "name": "displayInApp",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableFrom",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "availableTo",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "Package",
                  "abstractKey": "__isPackage"
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StorePackageModal_package"
            }
          ],
          "type": "MembershipPackage",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RootQueryType",
  "abstractKey": null
};

(node as any).hash = "a5b07f6c7db20919d7d177c10a9147da";

export default node;
